type RuntimeDictionary = Record<string, string | undefined>;

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeDictionary;
  }
}

const runtimeConfig: RuntimeDictionary =
  typeof window !== "undefined" && window.__RUNTIME_CONFIG__
    ? window.__RUNTIME_CONFIG__
    : {};

const compiledEnv = process.env as RuntimeDictionary;

const hasRuntimeValue = (value: unknown): value is string =>
  typeof value === "string" && value.length > 0;

export const getEnv = (key: string, fallback = ""): string => {
  const runtimeValue = runtimeConfig[key];
  if (hasRuntimeValue(runtimeValue)) {
    return runtimeValue;
  }

  const compiledValue = compiledEnv[key];
  if (compiledValue !== undefined && compiledValue !== null) {
    return compiledValue;
  }

  return fallback;
};

export const env = new Proxy<RuntimeDictionary>({} as RuntimeDictionary, {
  get: (_, prop: string) => getEnv(prop)
}) as Record<string, string>;

export const runtimeConfigKeys = Object.freeze({ ...runtimeConfig });
